import React from "react";
import PropTypes from "prop-types";
import DHDialog from "./DHDialog";
import DHTextFieldSmall from "./DHTextFieldSmall";
import DHButtonSave from "./DHButtonSave";
import DHButtonClose from "./DHButtonClose";

class ConfirmKennwortDialog extends React.Component {

    render() {
        if( !this.props.visible ) {
            return "";
        }
        const footer = (
            <div>
                <DHButtonSave label="Absenden" onClick={() => this.props.callBackOnAbsenden()} />
                <DHButtonClose label="Abbrechen" onClick={() => this.props.callBackOnAbbrechen()} />
            </div>
        );

        return <DHDialog onClose={() => this.props.callBackOnAbbrechen()} title={this.props.header} buttons={[]} comp={<>
            <div>
                {this.props.textOben}
            </div>
            <div style={{marginTop: 20}}>
                Bitte Kennwort eingeben:
            </div>
            <div style={{marginTop: "20px"}}>
                <DHTextFieldSmall label="" id="id-kennwort" value={this.props.kennwort} width={150} onChange={(text) => this.props.changeKennwort(text)}/>
            </div>
            <div style={{marginTop: 20}}>
                {footer}
            </div>
        </>}/>
    }
}


ConfirmKennwortDialog.propTypes = {
    header: PropTypes.string.isRequired,
    textOben: PropTypes.string.isRequired,
    visible: PropTypes.bool.isRequired,
    callBackOnAbbrechen: PropTypes.func.isRequired,
    callBackOnAbsenden: PropTypes.func.isRequired,
};

export default ConfirmKennwortDialog;
